// 서버 호출 — 주소는 빌드 때 10_정식/DEPLOY.env 의 API_BASE 를 박는다(vite.config.ts)
export const API_BASE: string = __API_BASE__;

export class HttpError extends Error {
  status: number;
  body: unknown;
  constructor(status: number, body: unknown) {
    super(`HTTP ${status}`);
    this.status = status;
    this.body = body;
  }
}

export async function api<T>(path: string, init: { method?: string; token?: string | null; body?: unknown; signal?: AbortSignal } = {}): Promise<T> {
  const headers: Record<string, string> = {};
  if (init.token) headers.authorization = "Bearer " + init.token;
  if (init.body !== undefined) headers["content-type"] = "application/json";
  const r = await fetch(API_BASE + path, {
    method: init.method ?? (init.body !== undefined ? "POST" : "GET"),
    headers,
    body: init.body !== undefined ? JSON.stringify(init.body) : undefined,
    signal: init.signal,
    cache: "no-store",
  });
  const body = await r.json().catch(() => null);
  if (!r.ok) throw new HttpError(r.status, body);
  return body as T;
}
